import createInstance from '../http';
import config from '@/const/config';
const { request } = createInstance(config.shopBaseUrl);

export default {
  // 获取店铺列表 http://mock.qa.91jkys.com/project/212?moduleId=1014&interfaseId=7852
  getStoreList: params => request.get(`/api/merchant_search/1.0.0/searchShop`, { params }),
  // 获取门店信息 http://mock.qa.91jkys.com/project/212?moduleId=1014&interfaseId=7947
  getStoreInfo: params => request.get(`/api/merchant_info/1.0.0/queryShopInfo`, { params }),
  // 查询门店资质配送信息 http://mock.qa.91jkys.com/project/212?moduleId=1014&interfaseId=7971
  getExtension: params => request.get(`/api/merchant_info/1.0.0/queryExtension`, { params }),
  // 搜索门店联想列表 http://mock.qa.91jkys.com/project/212?moduleId=1014&interfaseId=7965
  getSearchSuggest: params => request.get(`/api/merchant_search/1.0.0/searchSuggest`, { params }),
  // 联系店铺客服
  creatSession: params => request.post(`/api/zy-operate-call/1.0/buyer_creat_session`, params) // 联系店铺客服
};
